/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FanRemixContestSubmissionNotificationActionData
 */
export interface FanRemixContestSubmissionNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotificationActionData
     */
    eventId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotificationActionData
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotificationActionData
     */
    submissionTrackId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotificationActionData
     */
    submitterUserId: string;
}

/**
 * Check if a given object implements the FanRemixContestSubmissionNotificationActionData interface.
 */
export function instanceOfFanRemixContestSubmissionNotificationActionData(value: object): value is FanRemixContestSubmissionNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "eventId" in value && value["eventId"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "submissionTrackId" in value && value["submissionTrackId"] !== undefined;
    isInstance = isInstance && "submitterUserId" in value && value["submitterUserId"] !== undefined;

    return isInstance;
}

export function FanRemixContestSubmissionNotificationActionDataFromJSON(json: any): FanRemixContestSubmissionNotificationActionData {
    return FanRemixContestSubmissionNotificationActionDataFromJSONTyped(json, false);
}

export function FanRemixContestSubmissionNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestSubmissionNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': json['event_id'],
        'entityId': json['entity_id'],
        'entityUserId': json['entity_user_id'],
        'submissionTrackId': json['submission_track_id'],
        'submitterUserId': json['submitter_user_id'],
    };
}

export function FanRemixContestSubmissionNotificationActionDataToJSON(value?: FanRemixContestSubmissionNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_id': value.eventId,
        'entity_id': value.entityId,
        'entity_user_id': value.entityUserId,
        'submission_track_id': value.submissionTrackId,
        'submitter_user_id': value.submitterUserId,
    };
}

